var _path, _path2, _rect, _path3, _rect2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFbSpeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.466 4.444H8.653a4.208 4.208 0 00-4.209 4.209v22.813a4.208 4.208 0 004.209 4.208h11.25l.02-11.16h-2.9a.684.684 0 01-.683-.681l-.014-3.597a.684.684 0 01.684-.687h2.894v-3.476c0-4.034 2.464-6.23 6.062-6.23h2.953c.377 0 .684.306.684.684v3.033a.684.684 0 01-.684.684l-1.812.001c-1.957 0-2.336.93-2.336 2.295v3.009h4.3c.41 0 .728.358.68.765l-.427 3.597a.684.684 0 01-.68.604H24.79l-.019 11.16h6.695a4.208 4.208 0 004.208-4.209V8.653a4.208 4.208 0 00-4.208-4.209z",
    fill: "url(#fb-speaker_svg__paint0_linear_3841_67464)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.466 4.444H8.653a4.208 4.208 0 00-4.209 4.209v22.813a4.208 4.208 0 004.209 4.208h11.25l.02-11.16h-2.9a.684.684 0 01-.683-.681l-.014-3.597a.684.684 0 01.684-.687h2.894v-3.476c0-4.034 2.464-6.23 6.062-6.23h2.953c.377 0 .684.306.684.684v3.033a.684.684 0 01-.684.684l-1.812.001c-1.957 0-2.336.93-2.336 2.295v3.009h4.3c.41 0 .728.358.68.765l-.427 3.597a.684.684 0 01-.68.604H24.79l-.019 11.16h6.695a4.208 4.208 0 004.208-4.209V8.653a4.208 4.208 0 00-4.208-4.209z",
    fill: "url(#fb-speaker_svg__paint1_linear_3841_67464)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2F54EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.483 25.49l-7.213 2.885h-1.957c-.724 0-1.313.59-1.313 1.313v1.604c0 .687.54 1.166 1.313 1.166h.495l.53 3.708c.03.216.215.376.433.376h1.75a.439.439 0 00.435-.487l-.344-3.06 5.87 2.349a.441.441 0 00.41-.044.437.437 0 00.191-.362v-9.042a.438.438 0 00-.6-.406zM36.377 29.154l1.459-1.166a.438.438 0 00-.547-.684l-1.459 1.167a.438.438 0 00.547.683zM36.377 32.263a.438.438 0 00-.547.684l1.459 1.166a.44.44 0 00.615-.069.438.438 0 00-.068-.615l-1.459-1.166zM37.562 30.271h-1.458a.438.438 0 000 .875h1.458a.438.438 0 000-.875z",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#fff",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb-speaker_svg__paint0_linear_3841_67464",
    x1: 36.297,
    y1: 4.731,
    x2: 4.737,
    y2: 36.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fb-speaker_svg__paint1_linear_3841_67464",
    x1: 35.605,
    y1: 4.514,
    x2: 4.513,
    y2: 35.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#4867AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7295E1"
  })))));
}

export default __webpack_public_path__ + "./fonts/fb-speaker.27eb76c5d8e6dbdc07f14dcab04ac0b3.svg";
export { SvgFbSpeaker as ReactComponent };